module.exports = __webpack_public_path__ + "img/file__icon-pdf.d66577fa.svg";